const SeparateDateTime = (dateString: string) => {
  var dateObject = new Date(dateString);
  if (isNaN(dateObject.getTime())) {
    dateObject = new Date();
  }

  // Extract date components
  var year = dateObject.getFullYear();
  var month = dateObject.getMonth() + 1; // Month is zero-based, so add 1
  var day = dateObject.getDate();

  // Extract time components
  var hours = dateObject.getHours();
  var minutes = dateObject.getMinutes();
  var seconds = dateObject.getSeconds();

  return {
    date: year + "-" + month + "-" + day,
    time: hours + ":" + minutes + ":" + seconds,
  };
};
export default SeparateDateTime;

// const SeparateDateTime = (dateString: string) => {
//     var dateObject = new Date(dateString);

//     // Format date and time based on user's locale
//     var formattedDate = dateObject.toLocaleDateString();
//     var formattedTime = dateObject.toLocaleTimeString();

//     console.log("Date:", formattedDate);
//     console.log("Time:", formattedTime);

//     return {
//         date: formattedDate,
//         time: formattedTime,
//     };
// };

// export default SeparateDateTime;
